import { ResponseCustom } from 'src/app/models/ResponseCustom';
import { Observable, Subscription } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { SimpleListConfig } from './../../models/simpleListConfig';
import { Component, Input, OnInit, Output, ViewChild, EventEmitter, OnDestroy, AfterViewInit } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatFormField } from '@angular/material/form-field';
import { cloneDeep } from 'lodash';
import * as _ from 'lodash';
import { Console } from 'console';
import { DialogCustomComponent } from '../dialog-custom/dialog-custom.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
    selector: 'simple-list',
    templateUrl: './simple-list.component.html',
    styleUrls: ['./simple-list.component.scss'],
})
export class SimpleListComponent implements AfterViewInit, OnDestroy {
    @Input() config: SimpleListConfig;
    @Input() data: any[];
    @Input() selectAllEvent: Observable<void>;
    @Output() resSelectLine = new EventEmitter();
    @Output() reloadTable = new EventEmitter();

    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild('matSelect', { static: false }) matSelect: MatSelect;
    @ViewChild('matFormField', { static: false }) matFormField: MatFormField;

    tableDataSource = new MatTableDataSource<any>([]);
    selection: any[] = [];

    cols;
    hasSelectedAll: boolean = false;

    private subscription: Subscription;
    color: string;

    constructor(public dialog: MatDialog) {}

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    ngAfterViewInit(): void {
        this.tableDataSource.data = this.data;
        this.cols = this.config.displayColumns.map((x) => x.field);

        if (this.config.useSortable) {
            this.tableDataSource.sort = this.sort;
        }

        this.verifyUsePaginator();

        if (this.selectAllEvent) {
            this.subscription = this.selectAllEvent.subscribe(() => {
                this.selectAll();
            });
        }
    }

    selectAll() {
        if (!this.hasSelectedAll) {
            this.selection = _.clone(this.tableDataSource.data);
        } else {
            this.selection = [];
        }

        this.hasSelectedAll = !this.hasSelectedAll;
        this.resSelectLine.emit(this.selection);
    }

    selectableLine(row: any) {
        if (!this.config.selection) return;

        switch (this.config.selection.type) {
            case 'multiple':
                var index = this.selection.indexOf(row);

                if (index === -1) {
                    this.selection.push(row);
                } else {
                    this.selection.splice(index, 1);
                }

                this.resSelectLine.emit(this.selection);

                break;

            case 'single':
                this.selection = [];
                this.selection.push(row);
                this.resSelectLine.emit(this.selection);

                break;
        }
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.tableDataSource.filter = filterValue.trim().toLowerCase();

        if (this.tableDataSource.paginator) {
            this.tableDataSource.paginator.firstPage();
        }
    }

    isSelected(row: any) {
        if (this.selection.indexOf(row) >= 0) {
            return true;
        } else {
            return false;
        }
    }

    verifyUsePaginator() {
        if (this.config.usePagination && this.config.page.totalElements > this.config.pageSize[0]) {
            this.tableDataSource.paginator = this.paginator;
            if (this.config.page.totalElements > _.last(this.config.pageSize)) {
                let index = this.config.pageSize.indexOf(this.config.page.totalElements);
                if (index === -1) this.config.pageSize.push(this.config.page.totalElements);
            }
            return true;
        } else {
            return false;
        }
    }

    changePage(ev: any) {
        let returnPaginator = {
            previousPageIndex: ev.previousPageIndex,
            pageSize: ev.pageSize,
            pageIndex: ev.pageIndex,
            length: ev.length,
        };

        this.reloadTable.emit(returnPaginator);
    }

    processRetorn(myJSON: any) {
        var myObj = JSON.parse(myJSON);
        let text: any;
        if (myObj) {
            text = myObj.filter(Boolean).join(`, `);
        }

        return text;
    }

    openDialog(param: any): void {
        const myObj = JSON.parse(param);
        var messagemodel = [];
        if (myObj.length == 0) {
            messagemodel.push('Não existe mensagem para esse erro!');
        } else {
            myObj.forEach(function (value) {
                messagemodel.push(value);
            });
        }

        const dialogRef = this.dialog.open(DialogCustomComponent, {
            width: '500px',
            data: messagemodel,
        });

        dialogRef.afterClosed().subscribe((res) => {
            this.color = res;
        });
    }
}
